// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__22BiT","inputWrap":"CustomTip_inputWrap__3YKoZ"};